import { message, Row } from 'antd';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';

import Loader from '~/components/Loader/Loader';
import { LoadingContext } from '~/contexts/LoaderContext';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
import { GeneralException } from '~/exceptions/generalException';
import { ABANDONED_PAGE_ROUTE, ERROR_PAGE_ROUTE, HOME_ROUTE } from '~/routing/routes';
import { CryptoService } from '~/services/CryptoService';
import { CyberSourceService, ValidatePaymentBody } from '~/services/CyberSourceService';
import { PaymentService } from '~/services/PaymentService';
import { logger } from '~/utils/func/logger';
import { isTransactionNotFoundError } from '~/utils/paymentResultUtils';

import './ValidatePayment.scss';

const ValidatePayment: React.FC = () => {
  const location = useLocation();
  const { push: redirect } = useHistory();

  const { startLoading, stopLoading } = useContext(LoadingContext);

  const { t } = useTranslation();

  const getTransactionDetails = useCallback(async (transactionRef: string) => {
    startLoading();
    try {
      const res = await PaymentService.getTransactionDetails(transactionRef);
      const {
        data,
        data: {
          transaction: { status },
        },
      } = res;

      logger.debug('own status', { prefix: 'ValidatePayment', data: status });

      if (data !== null && data !== undefined) {
        switch (
          status // transaction.status
        ) {
          case 'ACCEPTED': // successful
            redirect(HOME_ROUTE()); // SUCCESS_PAGE_ROUTE
            break;
          case 'PAYMENT_ALREADY_PROCESSED':
            redirect(HOME_ROUTE()); // Paiement déjà effectué
            break;
          case 'REFUSED': // failed REJECTED
            redirect(HOME_ROUTE());
            break;
          case 'PENDING':
            redirect(HOME_ROUTE());
            break;
          default:
            redirect(ERROR_PAGE_ROUTE());
            break;
        }
      } else {
        redirect(ERROR_PAGE_ROUTE());
      }
      stopLoading();
    } catch (error: unknown) {
      stopLoading();
      if (isTransactionNotFoundError(error)) {
        redirect(ABANDONED_PAGE_ROUTE());
        return;
      }
      const exception = (error as { response?: { data?: GeneralException } })?.response?.data as GeneralException;
      message.error(exception?.description || t('home:global:generalResponse'), 3);
    }
  }, []);

  const validatePayment = useCallback(async () => {
    logger.debug('INSIDE validate payment', { prefix: 'ValidatePayment' });
    const validateDetailsBody = JSON.parse(localStorage.getItem('validateDetails') as string) as ValidatePaymentBody;
    logger.debug('validateDetailsBody', { prefix: 'ValidatePayment', data: validateDetailsBody });
    try {
      const res = await CyberSourceService.validatePayment(validateDetailsBody);
      switch (res.data.status) {
        case 'ACCEPTED':
          getTransactionDetails(res.data.transactionRef);
          break;
        case 'REFUSED':
          getTransactionDetails(res.data.transactionRef);
          break;
        case 'REJECTED':
          getTransactionDetails(res.data.transactionRef);
          break;
        default:
          break;
      }
    } catch (error: any) {
      const exception = error.response?.data as GeneralException;
      message.error(exception.description || t('home:global:generalResponse'), 3);
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const transactionRef = String(queryParams.get('transactionRef'));
    // const id = String(queryParams.get('Id'));

    const cryptonit = new CryptoService();
    cryptonit.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = cryptonit.decryptData(localStorage.getItem('data') as string) as GetPaymentResponse;

    const transactionDetails = decryptData;
    // JSON.parse(localStorage.getItem('data') as string) as GetPaymentResponse;

    if (transactionRef !== transactionDetails.data.transactionRef) {
      return;
    }

    validatePayment();
    // getTransactionDetails(transactionRef);
  }, []);

  return (
    <div className="getPaymentStatus">
      <Row justify="center">
        <Loader />
      </Row>
    </div>
  );
};

export default ValidatePayment;
